var heading_default = {
  "fontElementMap": "OwGkd",
  "elementSpacing": "T-jvd",
  "headerOne": "gQX0H T-jvd",
  "headerTwo": "_26kYc T-jvd",
  "headerThree": "iED3l T-jvd",
  "headerFour": "_5hz2- T-jvd",
  "headerFive": "Qsdp2 T-jvd",
  "headerSix": "V5x2J T-jvd",
  "child": "E07CK"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
